import "./CmsNavigationMenu.scss";

import * as React from "react";
import * as PropTypes from "prop-types";

import CountryUtil from "shared/src/uidispatcherapi/CountryUtil";
import history from "shared/src/uidispatcherapi/BettyHistoryModule";
import { isFsdShop } from "shared/src/utils/ShopFlavor";
import MobileNavigationActions from "../../../actions/MobileNavigationActions";
import { getRole } from "shared/src/stores/SessionStore";

type Props = {
    miniShoppingCart: React.ReactNode;
    store: React.ReactNode;
    list: React.ReactNode;
    orders: React.ReactNode;
    storeId: string | undefined;
    customerId: string | undefined;
};

// declare the web component for TypeScript
declare global {
    namespace JSX {
        interface IntrinsicElements {
            "cms-navigation-container": any;
        }
    }
}

function getSiteCoreBaseUrl(): string | undefined | null {
    return CountryUtil.getOptionalConfig()?.siteCoreBaseUrl;
}

export function isConfigured(): boolean {
    return !!getSiteCoreBaseUrl();
}

export class CmsNavigationMenu extends React.Component<Props> {
    componentRef: React.RefObject<Element> = React.createRef();
    isOpen = false;

    componentDidMount() {
        if (customElements && !customElements.get("cms-navigation-container")) {
            const siteCoreBaseUrl = getSiteCoreBaseUrl();

            let url = siteCoreBaseUrl + "/data/apps/";
            if (isFsdShop()) {
                url += "fsd";
            } else {
                url += "mshop";
            }
            url += "?sc_device=webcomponent&components=navigation%20container";
            if (this.props.storeId) {
                url += `&storeid=${this.props.storeId}`;
            }
            if (this.props.customerId) {
                url += `&customerid=${this.props.customerId}`;
            }
            url += `&role=${getRole()}`;

            const script = document.createElement("script");
            script.src = url;

            if (document.head) {
                document.head.appendChild(script);
            }
        }

        if (this.componentRef.current) {
            this.componentRef.current.addEventListener("navigation:item:clicked", this.handleNavigationItemClicked);
        }
    }

    handleNavigationItemClicked = (ev: any) => {
        this.isOpen = false;
        MobileNavigationActions.CloseMobileMenu();
        if (ev.Type === "mshp") {
            const url = new URL(ev.Url);
            const basePath = history.getBaseName(url.pathname);
            if (!url.pathname.startsWith(basePath)) {
                // weird path, can't do internal navigation
                ev.preventDefault();
                return;
            }
            let path = url.pathname.slice(basePath.length);
            if (url.search) {
                path += "?" + url.search;
            }
            if (url.hash) {
                path += "#" + url.hash;
            }
            ev.preventDefault();
            this.context.router.push(path);
        }
    };

    toggleMobileMenu(state: boolean) {
        if (state !== this.isOpen) {
            if (this.componentRef.current) {
                this.isOpen = !this.isOpen;
                const ev = new Event("navigation:toggle:clicked", {
                    bubbles: true,
                    cancelable: true
                });
                this.componentRef.current.dispatchEvent(ev);
            }
        }
    }

    render() {
        return (
            <cms-navigation-container
                ref={this.componentRef}
                storeid={this.props.storeId}
                customerid={this.props.customerId}>
                <div slot="store" className="navigation-slot-store">
                    {this.props.store}
                </div>
                <div slot="list" className="navigation-slot-list" onClick={this.handleNavigationItemClicked}>
                    {this.props.orders}
                    {this.props.list}
                </div>
                <div slot="cart" className="navigation-slot-cart" onClick={this.handleNavigationItemClicked}>
                    {this.props.miniShoppingCart}
                </div>
                <div
                    slot="list-mobile"
                    className="navigation-slot-list-mobile"
                    onClick={this.handleNavigationItemClicked}>
                    {this.props.orders}
                    {this.props.list}
                </div>
            </cms-navigation-container>
        );
    }

    static contextTypes = {
        router: PropTypes.object.isRequired
    };
}
